import { useEffect } from "react";
import { useLocation } from "@/lib/router-compat";
import { scrollToId } from "@/lib/scrollToId";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Small delay so the target section has rendered on the new route.
      const id = window.setTimeout(() => scrollToId(hash), 80);
      return () => window.clearTimeout(id);
    }
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
